import type { FreeAssembly, SimulacaoFrete } from '../types'
import { formatarCep } from '../util/formatar'
import { apiV2 } from './api'

export const simularFrete = async (
  cep: string,
  variacaoId: number,
  quantidade = 0
): Promise<SimulacaoFreteResponse> => {
  try {
    const { request, data, status } =
      await apiV2.post<SimulacaoFreteResponseData>(
        '/canais/frete/simular-variacao',
        {
          cep: parseInt(formatarCep(cep)),
          variacao_id: variacaoId,
          quantidade,
        }
      )

    const dataFreight = {
      cotacoes: data?.cotacoes ?? [],
      cep_info: data?.cep_info,
    }

    return { data: dataFreight, status: status ?? request.status }
  } catch (err: any) {
    return {
      data: { cotacoes: [], cep_info: null },
      status: err.request.status as number,
    }
  }
}

export const mapToSimulacaoFrete = (
  data: SimulacaoFreteData[]
): SimulacaoFrete[] => {
  return data.map((simulacaoFreteData: SimulacaoFreteData) => ({
    id_anuncio: simulacaoFreteData.anuncio_id,
    mensagemErro: simulacaoFreteData.mensagem_erro,
    erro: !!simulacaoFreteData.mensagem_erro,
    opcoes:
      simulacaoFreteData.opcoes?.map((opcao: OpcaoData) => ({
        entrega: opcao.entrega,
        entrega_chave: opcao.entrega_chave,
        prazo_dias: opcao.prazo_dias,
        prazoEstimado: opcao.prazo_estimado,
        prazoHoras: opcao.prazo_horas ?? null,
        preco: opcao.preco,
      })) ?? [],
    lojasRetirada:
      simulacaoFreteData.lojas_retirada?.map((loja: LojasRetiradaData) => ({
        endereco: loja.endereco,
        loja: loja.loja,
        lojaId: loja.loja_id,
        prazo_dias: loja.prazo_dias,
        prazoEstimado: loja.prazo_estimado,
        prazoHoras: loja.prazo_horas,
      })) ?? [],
  }))
}

export type SimulacaoFreteResponse = {
  data: {
    cotacoes: SimulacaoFreteData[]
    cep_info: CepInfoData | null
  }
  status: number
}

export type SimulacaoFreteData = {
  anuncio_id: number
  mensagem_erro: string
  opcoes?: OpcaoData[]
  lojas_retirada?: LojasRetiradaData[]
}

export type CepInfoData = {
  rua: string
  cidade: string
  estado: string
}

export type SimulacaoFreteResponseData = {
  cep_info: CepInfoData | null
  cotacoes: SimulacaoFreteData[]
}

export type LojasRetiradaData = {
  endereco: string
  loja: string
  loja_id: number
  prazo_dias: number
  prazo_estimado: string
  prazo_horas: number
}

export type OpcaoData = {
  entrega: string
  entrega_chave: string
  prazo_dias: number
  prazo_estimado: string
  prazo_estimado_dia_semana: string
  prazo_horas?: number
  preco: number
  montagem_gratis: FreeAssembly[]
}
